function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef, createElement as _createElement } from 'react';
import { Tooltip, IconButton, DropdownMenu, DropdownMenuItem } from 'seagull';
import { EditLine, MoreVertical, TrashLine, TrashLiner24, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { useServiceAdvancedSettingsAdditionalSection } from "../../ServiceAdvancedSettings";
import ServicePanel, { getTestId } from "../../ServicePanel/ServicePanel";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import styles from "./DraftServiceInstance.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const DraftServiceInstance = /*#__PURE__*/forwardRef(function DraftServiceInstance(props, ref) {
  const {
    service,
    idx,
    canMoveDown,
    canMoveUp,
    isInvalid,
    isReadOnly = false,
    advancedSettingsProps,
    showErrors,
    serviceDetailsProps,
    onEditServiceNameAndDescription,
    onEditService,
    onRemoveService,
    onMoveDown,
    onMoveUp
  } = props;
  const serviceAdvancedSettingsAdditionalSection = useServiceAdvancedSettingsAdditionalSection(_objectSpread(_objectSpread({}, advancedSettingsProps), {}, {
    service,
    isReadOnly,
    testId: "draft-service-".concat(idx)
  }));
  const {
    INLINE_EDIT_MENU = false
  } = useFeatureFlags();
  return /*#__PURE__*/_createElement(ServicePanel, _objectSpread(_objectSpread({
    isVendor: true,
    showBadges: true,
    billingInitiationProps: {
      isExistingService: false
    },
    ignoreAmendments: true,
    context: "draft"
  }, serviceDetailsProps), {}, {
    key: service.id || idx,
    ref: ref,
    service: service,
    idx: idx,
    error: showErrors && isInvalid,
    isReadOnly: isReadOnly,
    additionalSections: [serviceAdvancedSettingsAdditionalSection],
    onEditServiceNameAndDescription: onEditServiceNameAndDescription,
    menu: !isReadOnly && /*#__PURE__*/_jsxs("div", {
      className: styles.inlineMenu,
      children: [!INLINE_EDIT_MENU && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: "Edit service for this proposal",
          children: /*#__PURE__*/_jsx(IconButton, {
            onClick: () => onEditService(service),
            "data-testid": "".concat(getTestId(idx), "inline-menu-edit"),
            children: /*#__PURE__*/_jsx(EditLine, {})
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: "Delete service for this proposal",
          children: /*#__PURE__*/_jsx(IconButton, {
            onClick: () => onRemoveService(service.id),
            "data-testid": "".concat(getTestId(idx), "inline-menu-delete"),
            children: /*#__PURE__*/_jsx(TrashLine, {})
          })
        })]
      }), (canMoveDown || canMoveUp || INLINE_EDIT_MENU) && /*#__PURE__*/_jsxs(DropdownMenu, {
        target: /*#__PURE__*/_jsx(IconButton, {
          className: INLINE_EDIT_MENU ? styles.ellipsisMenu : undefined,
          "data-testid": "".concat(getTestId(idx), "ellipsis-menu"),
          children: /*#__PURE__*/_jsx(MoreVertical, {})
        }),
        children: [(canMoveDown || canMoveUp) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(DropdownMenuItem, {
            iconStart: /*#__PURE__*/_jsx(WideArrowUpward, {}),
            "data-testid": "".concat(getTestId(idx), "move-up"),
            disabled: !canMoveUp,
            onClick: onMoveUp,
            children: "Move Up"
          }), /*#__PURE__*/_jsx(DropdownMenuItem, {
            iconStart: /*#__PURE__*/_jsx(WideArrowDownward, {}),
            "data-testid": "".concat(getTestId(idx), "move-down"),
            disabled: !canMoveDown,
            onClick: onMoveDown,
            children: "Move Down"
          })]
        }), INLINE_EDIT_MENU && /*#__PURE__*/_jsx(DropdownMenuItem, {
          iconStart: /*#__PURE__*/_jsx(TrashLiner24, {}),
          "data-testid": "".concat(getTestId(idx), "remove-service"),
          disabled: isReadOnly,
          onClick: () => onRemoveService(service.id),
          skin: "error",
          children: "Remove"
        })]
      })]
    })
  }));
});
export default DraftServiceInstance;